<template>
    <div class="w-8/9 m-auto p-5">
        <div class="flex justify-center postcode w-8/9">
                <div class="w-full">
                    <label class="block tracking-wide clcnsw-heading mb-5" for="postcode">
                        Where do you live?
                    </label>
                    <input
                        class="appearance-none
                            block
                            w-full

                            text-xl
                            text-gray-700
                            border
                            border-gray-200
                            rounded
                            py-3
                            px-4
                            mb-3
                            leading-tight
                            focus:outline-2 focus:outline-[#057FA7] focus:outline-offset-2
                            focus:bg-white
                            focus:border-gray-500"
                        id="postcode"
                        ref="postcode_input"
                        type="text"
                        autocomplete="postal-code"

                        placeholder="Start typing your postcode or suburb"
                        v-model="searchTerm"
                        @focus="postcode_focus = true"
                        @blur="hideDropdown"
                        @keydown="handleKeydown"
                        role="combobox"
                        :aria-expanded="isExpanded"
                        aria-controls="postcode-listbox"
                        aria-autocomplete="list"
                        :aria-activedescendant="activeDescendant"
                        aria-label="Search for your postcode or suburb"
                    >
                    <ul v-if="searchLocalities.length"
                        v-show="postcode_focus"
                        id="postcode-listbox"
                        role="listbox"
                        aria-label="Postcode suggestions"
                        class="w-full text-left text-black bg-white border border-gray-500 rounded"
                        ref="dropdown">
                        <li class="py-3 px-4">
                            Showing {{ searchLocalities.length }} of {{ postcodes.length }} results
                        </li>
                        <li
                            v-for="(location, index) in searchLocalities"
                            :key="location.id"
                            :id="'postcode-option-' + index"
                            role="option"
                            :aria-selected="highlightedIndex === index"
                            @click="selectPostcode(location); changePostcode(location)"
                            @mouseenter="highlightedIndex = index"
                            class="search-choice py-3 px-4 hover:drop-shadow-md cursor-pointer"
                            :class="{ 'bg-gray-100': highlightedIndex === index }"
                            >
                            {{ location.locality }} ({{ location.postcode }})
                        </li>
                    </ul>
                </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "PostCodes",
  inject: ['setPostCode', 'setLocality'],
  props: {
    postcode: Number
  },
  emits: [
    'update:postcode'
  ],
  data() {
    return {
      searchTerm: '',
      postcode_focus: false,
      postcodes: [],
      selectedPostcode: '',
      pcode_url: process.env.VUE_APP_POSTCODES_BASE_URL,
      highlightedIndex: -1
    };
  },
  computed: {
    searchLocalities() {
        if (this.searchTerm === ''){
            return []
        }

        let matches = 0

        return this.postcodes.filter(locality => {
            if (locality.locality.toLowerCase().includes(this.searchTerm.toLowerCase()) && matches < 10) {
                matches++
                return locality
            }
        })
    },
    isExpanded() {
        return this.searchLocalities.length > 0 && this.postcode_focus;
    },
    activeDescendant() {
        if (this.highlightedIndex >= 0 && this.highlightedIndex < this.searchLocalities.length) {
            return 'postcode-option-' + this.highlightedIndex;
        }
        return null;
    }
  },
  mounted() {
    this.loadPostcodes();
  },
  methods: {
    handleKeydown(event) {
        const maxIndex = this.searchLocalities.length - 1;

        switch (event.key) {
            case 'ArrowDown':
                event.preventDefault();
                if (this.searchLocalities.length > 0) {
                    this.highlightedIndex = this.highlightedIndex < maxIndex ? this.highlightedIndex + 1 : 0;
                }
                break;
            case 'ArrowUp':
                event.preventDefault();
                if (this.searchLocalities.length > 0) {
                    this.highlightedIndex = this.highlightedIndex > 0 ? this.highlightedIndex - 1 : maxIndex;
                }
                break;
            case 'Enter':
                if (this.highlightedIndex >= 0 && this.highlightedIndex < this.searchLocalities.length) {
                    event.preventDefault();
                    const location = this.searchLocalities[this.highlightedIndex];
                    this.selectPostcode(location);
                    this.changePostcode(location);
                }
                break;
            case 'Escape':
                event.preventDefault();
                this.postcode_focus = false;
                this.highlightedIndex = -1;
                break;
            case 'Tab':
                this.postcode_focus = false;
                this.highlightedIndex = -1;
                break;
        }
    },
    async loadPostcodes() {
      await axios
          .get(this.pcode_url)
          .then(response => {
            this.postcodes = response.data
          })
    },
    selectPostcode(location) {
        this.selectedPostcode = location.postcode
        this.searchTerm = location.locality
        this.setPostCode(location.postcode)
        this.setLocality(location.locality)
    },
    changePostcode(e){
        this.$emit('update:postcode', e.postcode)
    },
    hideDropdown(){
        setTimeout(this.setStatus, 500);
    },
    setStatus() {
        this.postcode_focus = false;
    }
  }
};
</script>

<style scoped>
.search-choice {
    transition: all .4s ease-in-out;
}
.search-choice:hover {
    /* color: #003A78; */
    transform:scale(1.01);
    background-color: white;
}
.hide-dropdown {
    display: none;
}
</style>